import { DarkSidebar } from "@Components/DarkSidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCircleInfo,
    faPhone,
    faEnvelope,
    faShieldHalved,
    faFileCheck,
} from "@fortawesome/pro-light-svg-icons";
import { Link } from "@inertiajs/react";

export function HelpSidebar({ title, className = "" }) {
    return (
        <DarkSidebar title={title} icon={faCircleInfo} className={className}>
            <div className="sidebar-header d-flex">
                <h2>Kontakta oss</h2>
            </div>
            <p className="lead">Hur kan vi hjälpa dig?</p>
            <div className="sidebar-content">
                <div className="row">
                    <div className="link-box">
                        <a
                            className="d-block"
                            href="mailto:transportekonomi@akeri.se"
                        >
                            <div className="content-box content-box-success text-center">
                                <FontAwesomeIcon
                                    icon={faEnvelope}
                                    className="text-primary"
                                />
                                <strong>
                                    <p className="mb-3">Maila supporten</p>
                                </strong>
                                <p>transportekonomi@akeri.se</p>
                            </div>
                        </a>
                    </div>
                    <div className="link-box">
                        <a className="d-block" href="tel:0105100303">
                            <div className="content-box content-box-success text-center">
                                <FontAwesomeIcon
                                    icon={faPhone}
                                    className="text-primary"
                                />
                                <strong>
                                    <p className="mb-3">Ring supporten</p>
                                </strong>
                                <p>010-510 03 03</p>
                            </div>
                        </a>
                    </div>
                    <div className="sidebar-link">
                        <p className="mb-0">
                            <Link
                                className="sidebar-link"
                                href="/terms-and-conditions"
                            >
                                <FontAwesomeIcon
                                    icon={faFileCheck}
                                    className="me-1"
                                />
                                Allmänna villkor
                            </Link>
                        </p>
                    </div>
                    <div className="sidebar-link">
                        <p className="mb-0">
                            <Link
                                className="sidebar-link"
                                href="/privacy-policy"
                            >
                                <FontAwesomeIcon
                                    icon={faShieldHalved}
                                    className="me-1"
                                />
                                Integritetspolicy
                            </Link>{" "}
                        </p>
                    </div>
                </div>
            </div>
        </DarkSidebar>
    );
}
